import { inject } from '@angular/core';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { Logger } from '@app/utils/logger';
import { environment } from '../../../environments/environment';
import { Session } from '../session/session.service';

/**
 * @description Websocket.
 * @exports
 * @returns {GraphQLWsLink}
 */
export function ws(): GraphQLWsLink {
  const session = inject(Session);

  const logger = Logger.getInstance('_GraphQLModule').child(`ws`);

  return new GraphQLWsLink(
    createClient({
      url: environment.WEBSOCKET_URI,
      /**
       * Retry connection.
       *
       * @returns {boolean}
       */
      shouldRetry: () => true,
      retryAttempts: 5,
      /**
       * Set connection params.
       *
       * @returns {Record<string, unknown>}
       */
      connectionParams: () => ({
        token: session.token,
        'content-language': session.lang
      }),
      on: {
        /**
         * WebSocket event listeners.
         */
        connected: () => {
          logger.debug(`WebSocket connected.`);
        },
        /**
         * WebSocket closed listener.
         *
         * @param {unknown} event - Close event.
         */
        closed: (event: any) => {
          logger.warn(
            `WebSocket closed. Code: ${event.code}, Reason: ${event.reason}`
          );
        },
        /**
         * WebSocket error listener.
         *
         * @param {unknown} error - Error object.
         */
        error: (error: any) => {
          logger.error(`WebSocket error:`, error);
        },
        /**
         * WebSocket ping listener.
         *
         * @param {boolean} received - Whether the ping was received.
         */
        ping: (received) => {
          logger.debug(`WebSocket ping ${received ? 'received' : 'sent'}.`);
        },
        /**
         * WebSocket pong listener.
         *
         * @param {boolean} received - Whether the pong was received.
         */
        pong: (received) => {
          logger.debug(`WebSocket pong ${received ? 'received' : 'sent'}.`);
        }
      }
    })
  );
}
